import { ampli } from '../../../../ampli';
import { PopupConfirmModal } from '../../../../components/common/modal/popup/PopupConfirmModal';
import { useDeleteMyOwnTractorMutation } from '../../../../hooks/api/user/mutations/useDeleteMyOwnTractor.mutation';
import { useGetUserProfile } from '../../../../hooks/user/useGetUserProfile';
import { IMachine } from '../../../../interfaces/Machine.interfaces';
import { IMyOwnTractor } from '../../../../interfaces/OwnTractor.interfaces';
import { getOpenMarketProductTitle } from '../../../../utils/getter/getOpenMarketProductTitle.util';

interface IConfirmDeleteOwnTractorModalProps {
  isModalOpen: boolean;
  handleModalClose: () => void;
  selectedTractor: IMyOwnTractor;
  refetchList: () => void;
}

export const ConfirmDeleteOwnTractorModal = ({
  isModalOpen,
  handleModalClose,
  selectedTractor,
  refetchList,
}: IConfirmDeleteOwnTractorModalProps) => {
  const { mutate: deleteOwnTractor } = useDeleteMyOwnTractorMutation();
  const { userProfile } = useGetUserProfile();

  const handleDeleteOwnTractorClick = () => {
    ampli.pvmClickMyDeleteOwnTractorDone({
      user_id: userProfile?.id || '',
      title: getOpenMarketProductTitle({
        brandName: selectedTractor.brand?.name,
        machine: selectedTractor.machine as IMachine,
      }),
    });
    deleteOwnTractor(
      {
        ownTractorId: selectedTractor.id,
      },
      {
        onSuccess: (data) => {
          refetchList();
          handleModalClose();
        },
      },
    );
  };

  return (
    <PopupConfirmModal
      isShow={isModalOpen}
      closeModal={() => {
        handleModalClose();
      }}
      title={'🗑 보유 트랙터를 삭제 합니다'}
      description={`등록하신 ${selectedTractor?.brand?.name} ${selectedTractor?.machine?.model}\n트랙터를 삭제합니다.\n\n재등록을 원하실 경우\n간단히 재등록해주세요!`}
      buttonArray={[
        {
          text: '삭제',
          onClick: () => {
            handleDeleteOwnTractorClick();
          },
          color: 'red',
        },
        {
          text: '취소',
          onClick: () => {
            handleModalClose();
          },
          color: 'gray',
        },
      ]}
    />
  );
};
